<template>
  <div class="v-confidence-survey">
    <template v-if="getStartConfidence >= 1">
      <div class="is-full">
        <h5 class="u-text--white u-text--center">
          How much do you now feel you know about careers in surveying?
        </h5>
      </div>
      <br />
      <div class="columns is-centered">
        <div class="column is-one-third">
          <a class="m-btn m-btn__primary"
          @click="updatingEndConfidence(1,'a lot')" to="/final-screen">A lot</a>
        </div>
        <div class="column is-one-third">
          <a class="m-btn m-btn__primary"
          @click="updatingEndConfidence(2, 'a little')" to="/final-screen">A little</a>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-one-third">
          <a class="m-btn m-btn__primary"
          @click="updatingEndConfidence(3, 'some')" to="/final-screen">Some</a>
        </div>
        <div class="column is-one-third">
          <a class="m-btn m-btn__primary"
          @click="updatingEndConfidence(4, 'nothing')" to="/final-screen">Nothing</a>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="is-full">
        <h5 class="u-text--white u-text--center">
          How much do you know about careers in surveying?
        </h5>
      </div>
      <br />
      <div class="columns is-centered">
        <div class="column is-one-third">
          <a class="m-btn m-btn__primary"
            @click="updatingStartConfidence(1, 'a lot')">A lot</a>
        </div>
        <div class="column is-one-third">
          <a class="m-btn m-btn__primary"
            @click="updatingStartConfidence(2, 'a little')">A little</a>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-one-third">
          <a class="m-btn m-btn__primary"
            @click="updatingStartConfidence(3, 'some')">Some</a>
        </div>
        <div class="column is-one-third">
          <a class="m-btn m-btn__primary"
            @click="updatingStartConfidence(4,'nothing')">Nothing</a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  methods: {
    ...mapActions(['updateStartConfidence', 'updateEndConfidence']),
    updatingStartConfidence(confidence, label) {
      this.updateStartConfidence(confidence);
      this.$gtm.trackEvent({
        event: 'ricscta-click',
        'ricscta-name': 'knowledge-start',
        'ricscta-label': label,
      });
      this.$router.push({ name: 'splash' });
    },
    updatingEndConfidence(confidence, label) {
      this.updateEndConfidence(confidence);
      this.$gtm.trackEvent({
        event: 'ricscta-click',
        'ricscta-name': 'knowledge-end',
        'ricscta-label': label,
      });
      this.$router.push({ name: 'pursueCareer' });
    },
  },
  computed: {
    ...mapGetters(['getStartConfidence']),
  },
};
</script>

<style lang="scss" scoped>
  .v-confidence-survey {
    margin-top: 170px;
  }
</style>




// WEBPACK FOOTER //
// src/components/ConfidenceSurvey.vue